import Tab from './Tab';
import TabList from './TabList';

export default { Tab, TabList };



// WEBPACK FOOTER //
// ./src/components/atoms/tabs/index.js